import { AssetLibrary } from '../models/story.model';
import { uniq } from 'lodash';

export function mergeAssetLibraries(current: AssetLibrary, addition: AssetLibrary): AssetLibrary {
  const uniqCombine = (a, b) => uniq([...a, ...b]);
  const lights = uniqCombine(current.lights, addition.lights);
  const tweens = uniqCombine(current.tweens, addition.tweens);
  const reflections = uniqCombine(current.reflections, addition.reflections);

  return {
    lights,
    tweens,
    reflections,
  };
}
